module.exports = __webpack_public_path__ + "static/media/share.25586663.svg";